module.exports = __webpack_public_path__ + "img/69000.04abedaa.jpg";